import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Region } from '@6grain/masofa-monolith-api-client/dictionaries';
import { RegionManagerService } from '@components/openstreetmap/managers/region-manager.service';
import { ServerTranslatePipe } from '@app/utils/pipes/server-translate-pipe';

type RegionDisplayAlign = 'left' | 'right' | 'center' | null;

@Component({
  selector: 'app-region-display',
  standalone: true,
  imports: [CommonModule, ServerTranslatePipe],
  templateUrl: './region-display.component.html',
  styleUrl: './region-display.component.scss',
})
export class RegionDisplay implements OnChanges {
  @Input({ required: true }) regionId!: string | null | undefined;
  @Input() cssClass = '';
  /** Optional horizontal alignment for the whole block. */
  @Input() align: RegionDisplayAlign = null;
  /** Show the parent region part. Default: true */
  @Input() showRegion = true;
  /** Show the district part. Default: true */
  @Input() showDistrict = true;

  private regionManager = inject(RegionManagerService);

  region: Region | undefined;
  regionParent: Region | undefined;
  loading = false;

  private allRegions: Region[] = [];

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['regionId']) {
      await this.resolve();
    }
  }

  private async resolve(): Promise<void> {
    if (!this.regionId) {
      this.region = undefined;
      this.regionParent = undefined;
      return;
    }

    this.loading = true;

    try {
      if (this.allRegions.length === 0) {
        this.allRegions = await this.regionManager.getRegions();
      }

      this.region = this.allRegions.find(r => r.id === this.regionId);

      const parentId = (this.region as any)?.parentId;
      this.regionParent = parentId && parentId !== this.region?.id
        ? this.allRegions.find(r => r.id === parentId)
        : undefined;
    } finally {
      this.loading = false;
    }
  }
}
